(function () {
  'use strict'

  require('./glow-modal')
  require('./scss/glow-modal.scss')

  var MODULE_NAME = 'thismoment.glow.component.glow-modal'

  angular
    .module(MODULE_NAME, [
      'thismoment.glow.component.glow-modal.core'
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-modal/index.js